















































import { getConfig } from '@superbet-group/web.lib.config';
import { defineComponent } from '@vue/composition-api';

import { WikiPath } from '@modules/wiki/WikiPath';

export default defineComponent({
    name: 'PrivacyConsentWithdrawalInfo',
    setup() {
        return {
            privacyEmail: getConfig().countrySpecific.privacyEmail,
            supportAddress: getConfig().countrySpecific.supportEmail,
            WikiPath,
        };
    },
});
